import { render, staticRenderFns } from "./fmItem.vue?vue&type=template&id=2c00ab8c&scoped=true&"
import script from "./fmItem.vue?vue&type=script&lang=js&"
export * from "./fmItem.vue?vue&type=script&lang=js&"
import style0 from "./fmItem.vue?vue&type=style&index=0&id=2c00ab8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c00ab8c",
  null
  
)

export default component.exports